export default "__VITE_ASSET__BJNiyUGY__"